import React from 'react'

const QuotationMark = ({ width = "25", height = "15", fill = "#000000" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 22 15" fill={fill} xmlns="http://www.w3.org/2000/svg">
<path d="M14.1807 7.48721H19.8218V1.84614H14.1807V7.48721ZM2.18074 7.48721H7.8218V1.84614H2.18074V7.48721ZM16.5731 14.3333L19.1244 8.99998H12.668V0.333374H21.3346V9.18971L18.891 14.3333H16.5731ZM4.5731 14.3333L7.1244 8.99998H0.667969V0.333374H9.33457V9.18971L6.891 14.3333H4.5731Z"fill={fill} />
</svg>

  )
}

export default QuotationMark